import type { ReactElement } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import AppLoadingScreen from '../../../components/AppLoadingScreen';
import APP_CONFIG from '@/app.config';
import useAppUser from '@/hooks/useAppUser';

type Props = {
  allowedRoles: readonly string[];
  children: ReactElement;
};

export default function RequireClaimRoute({ allowedRoles, children }: Props) {
  const location = useLocation();
  const { firebaseUser, role, loading, actif } = useAppUser();

  if (loading) {
    return <AppLoadingScreen message="Verification de votre acces..." minHeight="50vh" />;
  }

  if (!firebaseUser) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (!actif) {
    return <Navigate to="/login" replace />;
  }

  if (!role || !allowedRoles.includes(role)) {
    return <Navigate to={APP_CONFIG.roleRedirects[role || 'User'] || '/'} replace />;
  }

  return children;
}